import { useParams } from "react-router-dom";

import { connect, useSelector } from "react-redux";

import styles from "./OrganizationSettingsPage.module.css";
import { getUserOrganizationPermissions } from "../../utils/permissionsUtil.js";
import AccessDeniedPage from "../statusPages/AccessDeniedPage.js";
import { useEffect, useState } from "react";
import UnividCard from "../../generic/UnividCard.js";
import PlanUsageBar from "../reports/PlanUsageBar.jsx";
import ReportsChart from "../reports/ReportsChart.jsx";
import { Menu, MenuItem } from "@mui/material";
import { FaCircleXmark } from "react-icons/fa6";
import WebinarReportTable from "../reports/WebinarReportTable.jsx";
import axios from "axios";
import { VARIABLES } from "../../../strings/variables.js";

const getOrganizationHistoricalMonthlyRegistrations = async ({
  organizationId,
}) => {
  const apiUrl = `${VARIABLES.apiUrl}organization/${organizationId}/report/historical-monthly-registrations`;

  try {
    const { data: registrationsResponse } = await axios.get(apiUrl, {
      withCredentials: true,
    });

    return registrationsResponse.historicalMonthlyRegistrations;
  } catch (error) {
    console.error("Fetch failed:", error);
  }
};

const OrganizationReport = ({ organization }) => {
  const { organizationId } = useParams();

  const currentUser = useSelector((state) => state.user.currentUser);

  const permissions = getUserOrganizationPermissions(
    currentUser,
    organizationId,
  );

  const isAdmin = permissions?.admin;
  const hasAccess = isAdmin || currentUser?.is_super_user;
  const hasCreateAccess = permissions?.room?.create;

  const [monthlyRegistrations, setMonthlyRegistrations] = useState([]);

  const [menuAnchor, setMenuAnchor] = useState(null);

  if (!hasAccess && !hasCreateAccess) {
    return <AccessDeniedPage />;
  }

  useEffect(() => {
    const fetchData = async () => {
      const newMonthlyRegistrations =
        await getOrganizationHistoricalMonthlyRegistrations({
          organizationId,
        });
      setMonthlyRegistrations(newMonthlyRegistrations);
    };

    fetchData();
  }, []);

  const planLimit = 100;

  const reportData = Array.isArray(monthlyRegistrations)
    ? monthlyRegistrations.map(({ month, webinars, registrations }) => ({
        month,
        webinars,
        registrations,
        avgRegistrations:
          webinars > 0 ? Math.round(registrations / webinars) : 0,
      }))
    : [];

  const currentMonthRegistrations =
    monthlyRegistrations.at(-1)?.registrations ?? 0;

  const peakMonthRegistrations = Math.max(
    ...monthlyRegistrations.map((m) => m.registrations),
    0,
  );

  return (
    <div className={styles.TemplatesWrapper}>
      <div
        style={{
          display: "flex",
          marginTop: "1em",
          marginLeft: "0.5em",
          marginBottom: "1em",
          alignItems: "flex-start",
          gap: "2vw",
          flexDirection: "column",
        }}
      >
        <UnividCard
          useDefaultWidth={false}
          customPadding="calc(1em + 10px) 1em 1em calc(1em + 10px)"
        >
          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={() => setMenuAnchor(null)}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
          >
            <MenuItem
              onClick={() => {
                setMenuAnchor(null);
              }}
            >
              <FaCircleXmark style={{ marginRight: "5px" }} /> Delete
              organization
            </MenuItem>
          </Menu>
          <div>
            <div>
              {" "}
              <h2 style={{ fontSize: "20px", marginBottom: "2vh" }}>
                Webinar report
              </h2>
              <h3
                style={{
                  fontSize: "14px",
                  color: "#505050",
                  marginBottom: "3vh",
                }}
              >
                Overview of webinar activity for {organization.name}
              </h3>
            </div>
            <PlanUsageBar
              currentMonthRegistrations={currentMonthRegistrations}
              planLimit={planLimit}
              peakMonthRegistrations={peakMonthRegistrations}
            />
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "2vw" }}>
            <div style={{ width: "50%", maxWidth: "450px", flexGrow: 1 }}>
              <ReportsChart data={monthlyRegistrations.reverse()} />
            </div>

            {reportData?.length > 0 ? (
              <div style={{ flexGrow: 1 }}>
                <WebinarReportTable data={reportData} />{" "}
              </div>
            ) : (
              <p>Loading or no data available...</p>
            )}
          </div>
        </UnividCard>
      </div>

      <div className={styles.TemplateCardsContainer}></div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  isAuthenticated: state.user.isAuthenticated,
  isAuthenticatedUnauth: state.user.isAuthenticatedUnauth,
  organization: state.organization,
});

export default connect(mapStateToProps)(OrganizationReport);
